import React from 'react';
import { Link } from 'react-router';

import { Layout, Header, Navigation, Drawer, Content } from 'react-mdl/lib/Layout';

const routeMap = {
    'mailing-lists': 'Mailing Lists',
};

class App extends React.Component {
    renderTitle() {
        let path = this.props.location.pathname.split('/').filter(part => !!part);

        return (
            <span>
                {path.map((part, index, arr) => {
                    let text = routeMap[part] || part;
                    if (index + 1 === arr.length) {
                        return (<strong key={`header-title-${part}-current`}>{text}</strong>);
                    } else {
                        return (
                            <span key={`header-title-${part}`} style={{ color: '#ddd' }}>
                                <Link to={'/' + path.slice(0, index + 1).join('/')} style={{ color: '#ddd', textDecoration: 'none' }}>{text}</Link> /&nbsp;
                            </span>
                        );
                    }
                })}
            </span>
        );
    }

    render() {
        return (
            <div style={{position: 'absolute', top: '0', left: '0', right: '0', bottom: '0'}}>
                <Layout fixedHeader>
                    <Header title={this.renderTitle()}>
                        <Navigation>
                            <Link to="/mailing-lists">Mailing Lists</Link>
                            {/*<Link to="">Members</Link>*/}
                            {/*<Link to="">Sections</Link>*/}
                            {/*<Link to="">Attendance</Link>*/}
                        </Navigation>
                    </Header>
                    {/*<Drawer title="Title">*/}
                        {/*<Navigation>*/}
                            {/*<a href="">Link</a>*/}
                            {/*<a href="">Link</a>*/}
                            {/*<a href="">Link</a>*/}
                            {/*<a href="">Link</a>*/}
                        {/*</Navigation>*/}
                    {/*</Drawer>*/}
                    <Content>
                        {this.props.children}
                    </Content>
                </Layout>
        </div>
        );
    }
}

export default App;



/** WEBPACK FOOTER **
 ** ./src/App/App.js
 **/